import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// Context Providers
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';

// Layout
import Navigation from './components/Navigation';

// Public Pages
import HomePage from './pages/HomePage';
import FoundersPage from './pages/FoundersPage';
import CompanyPage from './pages/CompanyPage';
import ServicesPage from './pages/ServicesPage';
import LicensePage from './pages/LicensePage';
import BlogPage from './pages/blog/BlogPage';
import BlogPostPage from './pages/blog/BlogPostPage';

// Auth Pages
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import AuthErrorPage from './pages/AuthErrorPage';

// Product Pages
import GoraiLandingPage from './pages/gorai/GoraiLandingPage';
import GoraiDocsPage from './pages/gorai/GoraiDocsPage';
import GoraiInfoPage from './pages/gorai/GoraiInfoPage';

import './App.css';

// react-router changes the URL without a page load, so the GoatCounter
// beacon (which only fires on initial load) needs to be told about each
// route change explicitly.
function GoatCounterTracker() {
  const location = useLocation();

  React.useEffect(() => {
    if (window.goatcounter && window.goatcounter.count) {
      window.goatcounter.count({
        path: location.pathname + location.search + location.hash,
      });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <GoatCounterTracker />
          <div className="app">
            <Navigation />
            <AnimatePresence mode="wait">
              <Routes>
              {/* ====== PUBLIC ROUTES ====== */}
              <Route path="/" element={<HomePage />} />
              <Route path="/company" element={<CompanyPage />} />
              <Route path="/founders" element={<FoundersPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/license" element={<LicensePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />

              {/* ====== AUTH ROUTES ====== */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/callback" element={<AuthCallback />} />
              <Route path="/auth-error" element={<AuthErrorPage />} />

              {/* ====== PRODUCT ROUTES - GORAI ====== */}
              <Route path="/gorai" element={<GoraiLandingPage />} />
              <Route path="/gorai/docs/*" element={<GoraiDocsPage />} />
              <Route path="/gorai/info/*" element={<GoraiInfoPage />} />

              {/* ====== CATCH ALL ====== */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AnimatePresence>
        </div>
      </Router>
    </AuthProvider>
  </ThemeProvider>
  );
}

export default App;
